import { render } from "./PartsDetail.vue?vue&type=template&id=7f8ebb60&scoped=true"
import script from "./PartsDetail.vue?vue&type=script&lang=js"
export * from "./PartsDetail.vue?vue&type=script&lang=js"

import "./PartsDetail.vue?vue&type=style&index=0&id=7f8ebb60&scoped=true&lang=css"

import exportComponent from "/Users/maru/Desktop/東野材木/hojokin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8ebb60"]])

export default __exports__